import { ChangeEvent, FC } from 'react'
import Backdrop from '@mui/material/Backdrop'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { XlsxAllowedTypes } from 'src/enums'
import { useAddPopupMessage } from 'src/hooks/ui'
import { useNavigate } from 'react-router-dom'
import { useUploadSensorsRequest } from 'src/hooks/api'

const allowedTypes = [XlsxAllowedTypes.Xls, XlsxAllowedTypes.Xlsx]

export const UploadSensors: FC = () => {
  const navigate = useNavigate()
  const addMessage = useAddPopupMessage()
  const { isLoading, mutate } = useUploadSensorsRequest({
    options: {
      onSuccess: (upload) => {
        navigate(`/sensors/uploads/${upload.id}`)
      },
      onError: ({ message: text }) => {
        addMessage({ text, type: 'error' })
      }
    }
  })
  const onFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const { files } = event.target
    if (!files || files?.length === 0) return
    const [file] = Array.from(files)
    const isTypeAllowed = allowedTypes.some((type) => file.type === type)
    if (isTypeAllowed) {
      mutate(file)
    } else addMessage({ text: 'Incorrect file type', type: 'error' })
  }

  return (
    <>
      <Button component="label" endIcon={isLoading ? <CircularProgress size={15} sx={{ color: 'white' }} /> : null} variant="contained" disabled={isLoading}>
        Upload Sensors
        {!isLoading && <input type="file" hidden onChange={onFileChange} />}
      </Button>
      <Backdrop open={isLoading} sx={{ zIndex: (theme) => theme.zIndex.modal + 1, color: 'common.white' }}>
        <Grid container direction="column" alignItems="center" spacing={2}>
          <Grid item>
            <CircularProgress color="inherit" />
          </Grid>
          <Grid item>
            <Typography variant="body1" px={2} textAlign="center">
              Uploading sensors and generating QR codes. This can take about a minute — please keep this page open.
            </Typography>
          </Grid>
        </Grid>
      </Backdrop>
    </>
  )
}
